import type { PayLinkRow } from "@/domain/payLinks/payLinkRow";
import type { PayLinkRow as PayLinkApiRow } from "@/types/api";

export function mapPayLinkApiRow(row: PayLinkApiRow): PayLinkRow {
  return {
    invoice_id: row.invoice_id,
    invoice_number: row.invoice_number?.trim() || row.invoice_id,
    customer_id: row.customer_id,
    customer_name: row.customer_name?.trim() ?? "",
    customer_email: row.customer_email?.trim() ?? null,
    amount: row.amount,
    currency: row.currency,
    status: row.status,
    created: row.created,
    due_date: row.due_date ?? null,
    hosted_url: row.hosted_url?.trim() ?? "",
  };
}
